export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: '¿Cómo recibo el Megapack después de comprar?',
    answer:
      'Después de confirmar el pago recibís un mail con el acceso a todos los materiales. Es 100% digital y podés abrirlo desde el celular, la tablet o la computadora.',
  },
  {
    question: '¿Qué incluye exactamente?',
    answer:
      'Incluye 6 tomos en PDF, 5 bonos profesionales, acceso inmediato y garantía de 7 días.',
  },
  {
    question: '¿Sirve si trabajo sola en consultorio privado?',
    answer:
      'Sí. Está pensado para nutricionistas que quieren ordenar sus consultas, organizar mejor sus seguimientos y trabajar con más estructura, incluso si atienden de forma independiente.',
  },
  {
    question: '¿Sirve si soy recién recibida?',
    answer:
      'Sí. Te ayuda a tener una guía clara para no sentir que cada consulta empieza desde cero. También sirve si ya tenés experiencia pero querés ordenar mejor tu forma de trabajar.',
  },
  {
    question: '¿Son planillas editables o archivos listos para completar?',
    answer:
      'No. Esta oferta incluye los tomos y bonos en PDF. Las planillas, plantillas y recursos editables se ofrecerán aparte como complemento opcional.',
  },
  {
    question: '¿Me va a ayudar a ahorrar tiempo?',
    answer:
      'Sí. El objetivo del Megapack es darte una estructura clara para preparar, conducir y seguir tus consultas sin improvisar todo desde cero.',
  },
  {
    question: '¿Tiene garantía?',
    answer:
      'Sí. Tenés 7 días para revisar el material. Si sentís que no era lo que buscabas, te devolvemos el 100% de tu dinero.',
  },
]
